// It's important to keep this order, the children need to come before the parent routes.
const routesConfig = [
  {
    path: '/admin/dashboard',
    label: 'routes.dashboard',
    icon: 'home',
    componentKey: 'DashboardPage',
    layout: '/admin/admin',
    isAdmin: false,
    allowedRoles: [
      'super-admin',
      'organization-manager',
      'team-manager',
      'device-manager',
      'client-reviewer',
      'client-manager',
      'session-reviewer',
      'treatment-configuration-manager',
      'treatment-manager',
      'client-role',
      'device-role',
      'domain-administrator',
    ],
  },
  {
    path: '/admin/organizations',
    label: 'routes.organizations',
    icon: 'organizations',
    componentKey: 'Organizations',
    containerName: 'organizations-container',
    layout: '/admin/admin',
    isAdmin: true,
    allowedRoles: ['super-admin', 'logistics-admin'],
  },
  {
    path: '/admin/teams/:id',
    componentKey: 'TeamDetail',
    hide: true,
    exact: true,
  },
  {
    path: '/admin/teams',
    label: 'routes.teams',
    icon: 'teams',
    componentKey: 'TeamsTable',
    layout: '/admin/admin',
    isAdmin: true,
    allowedRoles: [
      'super-admin',
      'organization-manager',
      'team-manager',
      'logistics-admin',
    ],
  },
  {
    path: '/admin/practitioners/:id',
    componentKey: 'PractitionerDetailPage',
    hide: true,
    exact: true,
  },
  {
    path: '/admin/practitioners',
    label: 'routes.practitioners',
    icon: 'practitioners',
    componentKey: 'PractitionersTable',
    layout: '/admin/admin',
    isAdmin: true,
    allowedRoles: ['super-admin', 'organization-manager', 'logistics-admin'],
  },
  {
    path: '/admin/remote-view',
    componentKey: 'DeviceDetailPage',
    hide: true,
    exact: true,
    allowedRoles: ['super-admin', 'organization-manager', 'logistics-admin'],
  },
  {
    path: '/admin/help-center',
    containerName: 'help-center',
    componentKey: 'HelpCenter',
    hide: true,
    exact: true,
  },
  {
    path: '/admin/devices/:id',
    componentKey: 'DeviceDetailPage',
    hide: true,
    exact: true,
  },
  {
    path: '/admin/devices',
    label: 'routes.devices',
    icon: 'devices',
    componentKey: 'DevicesTable',
    layout: '/admin/admin',
    allowedRoles: [
      'super-admin',
      'organization-manager',
      'team-manager',
      'device-manager',
      'domain-administrator',
      'device-admin',
    ],
  },
  {
    path: '/admin/clients/:id',
    componentKey: 'ClientDetail',
    hide: true,
    exact: true,
  },
  {
    path: '/admin/clients',
    label: 'routes.clients',
    icon: 'clients',
    componentKey: 'ClientsTable',
    layout: '/admin/admin',
    allowedRoles: ['team-manager', 'client-reviewer', 'client-manager'],
  },
  {
    path: '/admin/treatments/create',
    componentKey: 'CreateTreatmentWizard',
    hide: true,
    exact: true,
  },
  {
    path: '/admin/treatments',
    label: 'routes.treatments',
    icon: 'treatment',
    componentKey: 'TreatmentsTable',
    layout: '/admin/admin',
    allowedRoles: [
      'organization-manager',
      'treatment-configuration-manager',
      'treatment-manager',
    ],
  },
  {
    path: '/admin/sessions/:id',
    componentKey: 'SessionDetail',
    hide: true,
    exact: true,
  },
  {
    path: '/admin/sessions',
    label: 'routes.sessions',
    icon: 'session',
    componentKey: 'SessionsTable',
    containerName: 'main-container',
    isOpenRoute: true,
    layout: '/admin/admin',
    allowedRoles: [
      'super-admin',
      'organization-manager',
      'client-reviewer',
      'client-manager',
      'session-reviewer',
      'client-role',
      'device-role',
      'domain-administrator',
    ],
  },
  {
    path: '/admin/billing',
    label: 'routes.billing',
    icon: 'billing-card',
    componentKey: 'BillingPage',
    containerName: 'main-container',
    isOpenRoute: true,
    layout: '/admin/admin',
    isBillingRoute: true,
    allowedRoles: [
      'super-admin',
      'organization-manager',
      'organization-manager',
      'client-reviewer',
      'client-manager',
      'session-reviewer',
    ],
  },
  {
    path: '/admin/account-management',
    componentKey: 'AccountManagementPage',
    isAdmin: false,
    hide: true,
  },
  {
    path: '/admin/admin-configuration',
    label: 'routes.admin-configuration',
    icon: 'admin-settings',
    componentKey: 'AdminPage',
    containerName: 'main-container',
    isOpenRoute: true,
    layout: '/admin/admin',
    isAdmin: true,
    allowedRoles: ['super-admin'],
  },
  {
    path: '/admin/360-video-request',
    label: 'routes.request-video',
    icon: 'video-request',
    componentKey: 'RequestVideo',
    layout: '/admin/admin',
    allowedRoles: [
      'organization-manager',
      'treatment-configuration-manager',
      'treatment-manager',
    ],
  },
];

export default routesConfig;
